<ng-template #acknowledgeModal>
  <div class="card acknowledgePopup" dir={{langDirection}}>
    <div class="modal-header">
      <div (click)="dismissModal()" class="close_icon">
        <img src="assets/images/popup_close_button.svg" alt="close icon" />
      </div>
    </div>
    <div class="modal-body popup-body">
      <img class="tick_img" alt="tick image"/>
      <h2><span>{{titleText}}</span></h2>
      <div class="card_desc">
        <span>{{acknowledgementDesc}}</span>
      </div>
    </div>
  </div>
</ng-template>